var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatTransporte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_transporte",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-car-3",
    d: "M155.655,30.117a3.353,3.353,0,0,1,3.312,3.39v3.464c0,5.376-6.133,6.7-10.7,6.7L141.07,30.117Zm-9.545,23.768a49.689,49.689,0,0,1,6.266,24.853c0,9.288-2.63,17.172-6.657,26.988v12.521a6.705,6.705,0,0,1-6.624,6.779h-9.935a6.705,6.705,0,0,1-6.624-6.779v-6.779H36.43v6.779a6.705,6.705,0,0,1-6.624,6.779H19.871a6.705,6.705,0,0,1-6.624-6.779V105.727C9.22,95.91,6.591,88.026,6.591,78.738a49.689,49.689,0,0,1,6.266-24.853c5.491-10.42,12.26-23.409,19.407-35.6C37.748,8.912,40.623,6.708,47.352,5.474,57.5,3.61,66.68,3,79.484,3s21.984.61,32.131,2.474c6.73,1.234,9.6,3.437,15.089,12.806C133.85,30.477,140.62,43.466,146.111,53.886ZM39.742,74.183a9.938,9.938,0,1,0-9.935,10.169A10.058,10.058,0,0,0,39.742,74.183Zm66.236,6.779a3.353,3.353,0,0,0-3.312-3.39H56.3a3.391,3.391,0,0,0,0,6.779h46.365A3.353,3.353,0,0,0,105.978,80.962Zm19.48-37.469s-4.9-12.379-10.8-21.3a8.844,8.844,0,0,0-5.756-3.837,154.017,154.017,0,0,0-29.416-2.434,154.017,154.017,0,0,0-29.416,2.434,8.8,8.8,0,0,0-5.756,3.837c-5.9,8.915-10.8,21.3-10.8,21.3,10.863,2.122,28.541,3.369,45.975,3.369S114.6,45.615,125.458,43.493ZM139.1,74.183a9.938,9.938,0,1,0-9.935,10.169A10.058,10.058,0,0,0,139.1,74.183ZM17.9,30.117H3.312A3.353,3.353,0,0,0,0,33.507v3.464c0,5.376,6.133,6.7,10.7,6.7Z",
    transform: "translate(21 36)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatTransporte);
export default __webpack_public_path__ + "static/media/cat_transporte.a18d93ac.svg";
export { ForwardRef as ReactComponent };